var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"view-button-steam btn btn-purple",attrs:{"href":_vm.constants.LINK_TO_STEAM,"target":"_blank"}},[_c('img',{attrs:{"alt":"Steam","src":require("@/Asset/image/button/steam.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }